import React, { useMemo } from "react";
import {
    FORM_1099_BOX_FILTER_UNASSIGNED,
    FORM_1099_BOX_FILTER_UNASSIGNED_LABEL,
    FORM_1099_BOX_OPTIONS,
    Form1099BoxFilterValue,
} from "@common/constants/domains/accounting/form1099Box";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../EnumMultiselectFilter/EnumMultiselectFilter.module.scss";

const options: Array<FilterMultiselectOption<Form1099BoxFilterValue>> = [
    {
        value: FORM_1099_BOX_FILTER_UNASSIGNED,
        label: FORM_1099_BOX_FILTER_UNASSIGNED_LABEL,
        searchableLabel: FORM_1099_BOX_FILTER_UNASSIGNED_LABEL,
    },
    ...FORM_1099_BOX_OPTIONS.map((option) => ({
        value: option.value,
        label: `${option.boxNumber}: ${option.boxDescription}`,
        searchableLabel: `${option.label} ${option.boxDescription}`,
        section: option.form,
    })),
];

const matchesSearchableLabel = (
    search: string,
    option: FilterMultiselectOption<Form1099BoxFilterValue>,
) =>
    (option.searchableLabel ?? "").toLowerCase().includes(search.toLowerCase());

export const Form1099BoxFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = useMemo(
        () => filters.form1099Boxes ?? [],
        [filters.form1099Boxes],
    );

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                filterFn={matchesSearchableLabel}
                options={options}
                value={value}
                onChange={(selected) =>
                    onChange({
                        form1099Boxes:
                            selected.length > 0 ? selected : undefined,
                    })
                }
                name="form1099Boxes"
            />
        </div>
    );
};
